import RowItemListReceptionUnexpectedly from './RowItemListReceptionUnexpectedly.jsx';
export {
  RowItemListReceptionUnexpectedly
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-unexpectedly/datatable/list/index.js